import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiToolbar: Overrides['MuiToolbar'] = {
  root: {
    backgroundColor: pallete.common.black,
  },
};

export default MuiToolbar;
